import type { CommunityType } from '~/entities/container/community/interfaces/community'
import type { CatiaCollabEvent } from '~/entities/container/conversation/interfaces/events'
import type { IMediaType } from '~/entities/content/media/interfaces/media-type'
import type { IUser } from '~/entities/user/user/interfaces/user'

import type { UserEndorseResponse } from '~/features-swym/comment/interfaces/swym-comments'

import type { IContentModel } from '~/features-shared/content/interfaces/content-model'
import type { IEntity, SUBJECT_6W_URI } from '~/features-shared/libs/interfaces/entity'
import type { RTCTextContent } from '~/features-shared/rtconv/interfaces/rtconversation'

export interface ITimeline extends IEntity {
  'status': TimelineStatus
  'thread_id': string
  'community_type': CommunityType
  'community_id': string
  'community_subject_uri': string
  'message_type': 'INTERNAL_EVENT' | 'INTERNAL_CONTENT' | 'INSTANT_MESSAGE'
  'message_uri': string
  'subject_uri': string
  'subject_state': string
  'external_app_id': string
  'author': IUser
  'modification_date': string
  'message_details': MessageDetails
  'from_index': boolean
  'triggered_by': any
  'currentUserEndorse': UserEndorseResponse
  // Generic Key to pass data from Request to Response call
  'X-Request-ID': string
}

export enum TimelineStatus {
  SENT,
  PENDING,
  ERROR,
}

export interface IMessageDetailsInternalEvent {
  /** Action of the internal event. */
  action: 'create' | 'update' | 'titleUpdated' | 'userRemoved' | string

  attendees?: { login: string, initials: string }[]

  /** The conversation auto removal is enabled. */
  autoRemovalEnabled?: boolean

  /** The type of call. Right now only "catiaCollab" */
  call_type?: 'catiaCollab'

  commentable_uri: string

  /** Title of the status. */
  ideation_status?: string

  /** Action performed on the status. */
  ideation_status_action?: string

  is_persistent?: boolean
  member_ids?: string | IUser[]
  model: 'Comment' | 'Answer' | '' | 'Externaldm' | string
  model_content: string
  model_id: string
  model_state: 'ACTIVE' | string
  model_uri: string
  moderation_state: 'notModerated' | string
  modification_date: string

  /** A unique identifier for the event in catia */
  msgId?: string

  /** number of wiki pages forwarded */
  nb_forwarded_contents?: number

  /** Defined if the subject is attached to a parent. */
  parent_uri?: string

  /** The identifier of the type of event for an event in catia */
  serviceId?: CatiaCollabEvent

  /** Id of the subject. */
  subject_id: string

  /** Type of the subject. */
  subject_model: IContentModel

  /** Topic of the conversation. */
  topic?: string

  /** Title of the event subject. */
  subject_title: string

  users?: IUser[] | string

  /** Maturity of the wedo. */
  wedo_maturity?: string
}

export interface IMessageDetails {
  content: string
  moderation_state: string
  parent_message?: Partial<IParentMessage>
  forwarded_from: any
  /** RTC textContent's currently used to store rephrasing queries but can  be to store other data */
  textContent?: RTCTextContent[]
  /** model of the message- post, media, comment, etc. */
  model?: 'Comment' | 'Answer' | 'Externaldm' | IContentModel

  type?: IMediaType
}

/** Message details containing only the subject URI of the message details content. */
export interface MessageDetailsWithOnlySubjectUri {
  /** Subject URI of the details message content. */
  subject_uri: SUBJECT_6W_URI
}

/** All kind of possible message details. */
export type MessageDetails = IMessageDetails | IMessageDetailsInternalEvent | MessageDetailsWithOnlySubjectUri

export interface IParentMessage {
  author: IUser
  message_details: {
    content: string
  }
  subject_uri: string
  message_id: string
  creation_date: string
}
